import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { BackendType } from '@/models/general';
import {
    Agency,
    AgencyWithCredentials,
    convertAgencyFromResponse,
} from '@/models/agency';

const baseUrl = urlBuilder('auth', 'agencies');

type GetAgenciesResponse = {
    agencies: Agency<BackendType>[];
};

export const agencyApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['AGENCIES'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getAgencies: builder.query<Agency[], void>({
                query: () => baseUrl,

                transformResponse(response: GetAgenciesResponse) {
                    return response.agencies.map(convertAgencyFromResponse);
                },

                providesTags: ['AGENCIES'],
            }),

            postAgency: builder.mutation<
                AgencyWithCredentials,
                AgencyWithCredentials
            >({
                query: (agency) => ({
                    url: baseUrl,
                    method: 'POST',
                    body: agency,
                }),
                invalidatesTags: ['AGENCIES'],
            }),

            deleteAgency: builder.mutation<void, Agency>({
                query: (agency) => ({
                    url: `${baseUrl}/${agency.id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['AGENCIES'],
            }),
        }),
    });

export const {
    useGetAgenciesQuery,
    usePostAgencyMutation,
    useDeleteAgencyMutation,
} = agencyApi;
